import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import JsonLd from '@/components/feature/JsonLd';
import BrandStory from './components/BrandStory';
import Testimonials from './components/Testimonials';
import ContactSection from './components/ContactSection';

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于香蕉视频 - 短视频创作与分享平台',
  description: '香蕉视频是专为内容创作者打造的短视频分享平台，提供海量原创视频内容、轻松上传发布、智能推荐算法。',
  url: 'https://www.bananavideo.cn/about',
};

const breadcrumbItems = [
  { label: '首页', href: '/' },
  { label: '关于我们' },
];

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <JsonLd data={aboutJsonLd} />

      <header>
        <Navbar />
      </header>

      <main className="pt-20">
        <Breadcrumb items={breadcrumbItems} />

        {/* Page Header */}
        <section className="w-full px-4 md:px-6 py-10 text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            关于香蕉视频
          </h1>
          <p className="text-sm md:text-base text-foreground-500 mt-4 max-w-2xl mx-auto leading-relaxed">
            香蕉视频是专为内容创作者打造的短视频分享平台。我们相信每个人都有独特的故事值得被看见，每一份才华都值得被放大。从2020年创立至今，我们已汇聚了超过500万创作者和8000万日活用户。
          </p>
        </section>

        <BrandStory />
        <Testimonials />
        <ContactSection />
      </main>

      <Footer />
    </>
  );
}